import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-600">精选每日大赛视频，高清流畅在线观看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group block rounded-xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded text-[11px] font-medium bg-black/70 text-white whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-2xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </span>
                  {item.views} 次观看
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {mediaItems.slice(3, 5).map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="relative w-full sm:w-56 aspect-video sm:aspect-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-[10px] font-medium bg-black/70 text-white whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col justify-center flex-1">
                <h3 className="text-sm font-medium text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </span>
                  {item.views} 次观看
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}